export default __webpack_public_path__ + "static-bigflip/media/icon-step-3.a2553863.png";